import {
    FETCH_INITIAL_STATEMENTS_DATA_REQUEST,
      FETCH_INITIAL_STATEMENTS_DATA_SUCCESS,
      FETCH_INITIAL_STATEMENTS_DATA_FAILURE,
    } from "./FetchInitialStatementsDataTypes";
    import api from "../../utils/Api";
    
    export const fetchInitialStatementsDataRequest = () => {
      return {
        type: FETCH_INITIAL_STATEMENTS_DATA_REQUEST,
      };
    };
    
    export const fetchInitialStatementsDataSuccess = (initialStatementsData) => {
      return {
        type: FETCH_INITIAL_STATEMENTS_DATA_SUCCESS,
        payload: initialStatementsData,
      };
    };
    
    export const fetchInitialStatementsDataFailure = (error) => {
      return {
        type: FETCH_INITIAL_STATEMENTS_DATA_FAILURE,
        payload: error,
      };
    };
    
    export const fetchInitialStatementsDataListing = () => {
      
      const headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      };
      let url = "payment/statement/dropdown/fetch";
    
      return async (dispatch) => {
        dispatch(fetchInitialStatementsDataRequest);
        try {
          const response = await api.get(url,
            {
              headers: headers,
            }
          );
          const initialStatementsData = response.data.data;
         // console.log("initialNotesData", initialStatementsData)
          dispatch(fetchInitialStatementsDataSuccess(initialStatementsData));
        } catch (error) {
          console.log("Redux error - ", error.response);
          const errorMsg = error.message;
          dispatch(fetchInitialStatementsDataFailure(errorMsg));
        }
      };
    };
    